import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Home from "./Pages/Home";
import EditorPage from "./Pages/EditorPage";
import CreateRoom from "./Pages/CreateRoom";
import Register from "./Pages/Register";
import Login from "./Pages/Login";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Navbar from "./Components/Navbar";
import Repls from "./Pages/Repls";
import Loading from "./Components/Loading";

function App() {
  return (
    <>
      <div>
        <Toaster
          position="top-right"
          toastOptions={{
            success: {
              iconTheme: {
                primary: "#0053a6",
              },
            },
            error: {
              iconTheme: {
                primary: "#0053a6",
              },
            },
          }}
        />
      </div>
        <BrowserRouter>
            <Navbar />
              <Loading/>    
              <Routes>
                <Route index path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/sign-up" element={<Register />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/create-room" element={<CreateRoom />} />
                <Route path="/editor/:roomId" element={<EditorPage />} />
                <Route path="/repls" element={<Repls />} />
              </Routes>
        </BrowserRouter>
    </>
  );
}

export default App;
